/**
 * Extract a user-friendly error message from an API error.
 * Safely handles missing response, data, or error fields.
 *
 * @param error - The caught error (typically from axios)
 * @param fallback - Default message if no specific message can be extracted
 * @returns A user-friendly error string
 */
export function getErrorMessage(error: any, fallback = 'Something went wrong. Please try again.'): string {
  // Backend returns { error: "message" } in response body
  const serverMessage = error?.response?.data?.error;
  if (typeof serverMessage === 'string' && serverMessage.length > 0) {
    // Strip the route prefix the backend adds (e.g., "/api/files/123: message")
    const colonIndex = serverMessage.indexOf(': ');
    if (colonIndex > 0 && serverMessage.startsWith('/')) {
      return serverMessage.substring(colonIndex + 2);
    }
    return serverMessage;
  }

  // Network error (no response from server)
  if (error?.message === 'Network Error') {
    return 'Unable to connect to the server. Please check your connection.';
  }

  // Timeout
  if (error?.code === 'ECONNABORTED') {
    return 'Request timed out. Please try again.';
  }

  return fallback;
}
